import createClient from 'openapi-fetch';

export const useGouvernementClient = () => {
  const geocodingClient = createClient<GouvernementApiPaths>({
    baseUrl: 'https://api-adresse.data.gouv.fr',
  });

  const searchAnAdress = async (address: string) => {
    const response = await geocodingClient.GET('/search', {
      params: {
        query: {
          q: address,
        },
      },
    });

    return response.data;
  };

  return {
    geocodingClient,
    searchAnAdress,
  };
};
